import { render, staticRenderFns } from "./CandidateListSmall.vue?vue&type=template&id=5e194f7a&scoped=true"
import script from "./CandidateListSmall.vue?vue&type=script&lang=js"
export * from "./CandidateListSmall.vue?vue&type=script&lang=js"
import style0 from "./CandidateListSmall.vue?vue&type=style&index=0&id=5e194f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e194f7a",
  null
  
)

export default component.exports